/* eslint-disable @typescript-eslint/ban-ts-comment */
import WorkspaceSubscriptionCheckoutModalContainer
	from 'src/containers/WorkspaceSubscriptionCheckoutModalContainer/WorkspaceSubscriptionCheckoutModalContainer';
import PricingSubscriptionSelectionModal from '../PricingSubscriptionSelectionModal/PricingSubscriptionSelectionModal';

import useSubsciptionPlanSelectionModal from './useSubsciptionPlanSelectionModal';

export type SubscriptionPlanSelectionModalProps = {
	stackOrder: number;
	onClose: ( workspaceCreated: boolean ) => void;
};

const SubscriptionPlanSelectionModal = ( { stackOrder = 1, onClose }: SubscriptionPlanSelectionModalProps ) => {
	const {
		workspace,
		pricingSubscriptionPresenter,
		onUpgradeButtonClicked,
		onNoWorkspaceButtonClicked,
		selectedPricingPlanPrice,
		closeCheckoutModal,
		onSuccessfulPaymentDialogAccepted,
		isShowingCheckoutModal,
		isCreatingWorkspace
	} = useSubsciptionPlanSelectionModal( { onClose } );

	return (
		<>
			<PricingSubscriptionSelectionModal
				// @ts-expect-error
				workspaceID={workspace.id}
				presenter={pricingSubscriptionPresenter}
				onClose={() => onClose( false )}
				onUpgradeButtonClicked={onUpgradeButtonClicked}
				onNoWorkspaceButtonClicked={onNoWorkspaceButtonClicked}
				stackOrder={stackOrder}
				isCreatingWorkspace={isCreatingWorkspace}
			/>
			{isShowingCheckoutModal && selectedPricingPlanPrice && (
				<WorkspaceSubscriptionCheckoutModalContainer
					// @ts-expect-error
					workspaceID={workspace.id}
					onClose={closeCheckoutModal}
					onSuccessfulDialogAccepted={onSuccessfulPaymentDialogAccepted}
					pricingPlanPrice={selectedPricingPlanPrice}
					stackOrder={stackOrder + 1}
				/>
			)}
		</>
	);
};

export default SubscriptionPlanSelectionModal;
